import { IsNotEmpty, IsEmail, MaxLength } from "class-validator";

export class AuthResetDTO {

    @IsNotEmpty()
    @IsEmail()
    @MaxLength(255)
    email: string;

}
